import { useState, useRef, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, locale } from '../../index';
import SimpleReactValidator from 'simple-react-validator';
import { toast } from 'react-toastify';
import { app } from "@microsoft/teams-js";
import { useTranslation } from 'react-i18next';
import { TailSpin } from 'react-loader-spinner'
import { AppContext } from '../../AppContext';
import { MdCancel,  MdCheckCircle } from 'react-icons/md';

function Login(props) {
	const [username, setUsername] = useState('');
	const [password, setPassword] = useState('');
	const [TFACode, setTFACode] = useState('');
	const [isDisable, setIsDisable] = useState(false);

	const [activateTFA, setActivateTFA] = useState(false);

	const [TFASecret, setTFASecret] = useState(null);
	const [TFAQRCode, setTFAQRCode] = useState(null);
	const [TFAValidCode, setTFAValidCode] = useState('');
	const [TFAValidCodeResult, setTFAValidCodeResult] = useState(null); // null | 0 | 1

	const [, forceUpdate] = useState();

	const navigate = useNavigate();
	const { t } = useTranslation();

	const validator = useRef(new SimpleReactValidator({locale: locale}));
	const appContext = useContext(AppContext)

	app.initialize()

	document.title = `${t('login')} | Infinity`

	useEffect(() => {
		app.getContext().then((context) => {
			if(Object.keys(context).length !== 0) {
				setUsername(context.user.loginHint);
			}
		});

		if(api.isLoggedIn()) {
			navigate(props.redirectUrl)
		}
		// eslint-disable-next-line
	}, [])

	const handleSubmit = async (event) => {
		event.preventDefault();

		if(validator.current.allValid()) {
			try {
				await api.init(username, password, false, TFACode);
			} catch(error) {
				console.error(error);
				setIsDisable(false);
				toast.error(t('invalid_username_and_password'));
				return;
			}

			try {
				const statusResp = await api.calls.user.tfa.status();

				if (statusResp.data.enabled === 0) {
					if (
						(statusResp.data.forced === 1) ||
						(statusResp.data.required === 1)
					) {
						setActivateTFA(true);

						// {
						//	"required": 1,
						//	"has_secret": 0,
						//	"whitelisted_ip": 0,
						//	"qr_code": "PD94...",
						//	"secret": "ASDFASDFASDF"
						// }

						const readResp = await api.calls.user.tfa.read();

						setTFASecret(readResp.data.secret);
						setTFAQRCode(readResp.data.qr_code);
					} else {
						toast.success(t('you_have_logged_in'));
						navigate(props.redirectUrl);
					}
				} else {
					toast.success(t('you_have_logged_in'));
					navigate(props.redirectUrl);
				}
			} catch(error) {
				console.error(error);
			}
		} else {
			validator.current.showMessages();
			setIsDisable(false);
			toast.error(t('enter_username_and_password'));
		}
	}

	const loginWithSso = async (event) => {
		event.preventDefault();

		if(validator.current.fieldValid('username')) {
			setIsDisable(true)
			await api.saml.tryThroughNewWindow(username)
			// eslint-disable-next-line
			.then(r => toast.success(t('you_signed_in_with_sso')))
			// eslint-disable-next-line
			.then(r => navigate(props.redirectUrl))
			// eslint-disable-next-line
			.catch(r => setIsDisable(false) || toast.error(t('you_dont_have_active_sso')))
			return;
		} else {
			validator.current.showMessageFor('username');
			forceUpdate(1);
		}
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const onClickValidate = async (_event) => {
		try {
			const valiResp = await api.calls.user.tfa.validate(TFAValidCode, TFASecret);
			setTFAValidCodeResult(valiResp.data.result === 1);
		} catch(error) {
			console.error(error);
			setTFAValidCodeResult(false);
		}
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const onClickActivate = async (_event) => {
		try {
			const activResp = await api.calls.user.tfa.create(TFASecret);

			if (activResp.data.result == 1) {
				toast.success(t('you_have_logged_in'));
				navigate(props.redirectUrl);
			} else {
				toast.error(t('tfa_problems_occured_durring_activation'));
			}
		} catch(error) {
			console.error(error);
			toast.error(t('tfa_problems_occured_durring_activation'));
		}
	}

	return (
		<div className="small-10 medium-7 large-4 large-centered medium-centered small-centered columns">
			{
				isDisable ?
					<span className='global-spinner'>
						<TailSpin
							color={appContext.themeType === 'dark' ? '#FFFFFF' : '#1f1f1f' }
							height="50"
							width="50"
						/>
					</span>
				: ''
			}
			{ activateTFA
			? (
				<div className="row login">
					<div className="callout box">
						<p className="tfa-info-text">{t('tfa_info_text_1')}</p>
						<div className="qr-code-spinner-container">
							{ typeof TFAQRCode === 'string' ? (
									<img
										className="tfa-qr-img"
										src={"data:image/svg+xml;base64," + TFAQRCode}
										style={{width: "12rem", height: "12rem"}}
									/>
							) : (
									<TailSpin
										color={appContext.themeType === 'dark' ? '#FFFFFF' : '#1f1f1f' }
										height="50"
										width="50"
									/>
							)}
						</div>
						<hr/>
						<p className="tfa-info-text">{t('tfa_info_text_2')}</p>
						<div className="tfa-code-validation-wrapper">
							<input
								className="tfa-code-validation-input"
								value={TFAValidCode}
								type="text"
								name="TFA validation code"
								placeholder={t('tfa_enter_tfa_code')}
								onChange={event => setTFAValidCode(event.target.value)}
							/>
							<div className="tfa-code-validation-icon">
								{TFAValidCodeResult !== null && (TFAValidCodeResult
								? (
									<MdCheckCircle className="tfa-code-validation-icon-success"/>
								) : (
									<MdCancel className="tfa-code-validation-icon-error"/>
								))}
							</div>
							<button
								className="button tfa-validate-button"
								onClick={onClickValidate}
								disabled={TFAQRCode === null}
							>
								{t('tfa_validate')}
							</button>
						</div>
						<hr />
						<button
							className="button"
							onClick={onClickActivate}
							disabled={TFAQRCode === null}
						>
							{t('tfa_activate')}
						</button>
					</div>
				</div>
			) : (
				<div className="row login">
					<a className="logo-center" href="#">
						<img src="/www/img/infracom/logo-new.png" alt="Logo" />
					</a>
					<div className="callout box">
						<form onSubmit={handleSubmit}>
							<label>
								{t('username')}
								<input
									id="username"
									type="text"
									name="username"
									value={username}
									onChange={event => setUsername(event.target.value)}
									onBlur={()=>validator.current.showMessageFor('username')}
								/>
								{validator.current.message('username', username, 'required|email')}
							</label>
							<label>
								{t('password')}
								<input
									type="password"
									name="password"
									value={password}
									onChange={event => setPassword(event.target.value)}
								/>
								{validator.current.message('password', password, 'required')}
							</label>
							<label>
								{t('tfa_code_input_placeholder')}
								<input
									type="text"
									name="TFA codeb"
									value={TFACode}
									onChange={event => setTFACode(event.target.value)}
								/>
							</label>
							<div className="row">
								<div className="small-12 columns">
									<input
										disabled={isDisable}
										className="button"
										type="submit"
										value={t('login')}
									/>
								</div>
								<div className="small-12 columns">
									<input
										disabled={isDisable}
										className="button"
										type="submit"
										value={t('login_with_sso')}
										onClick={loginWithSso}
									/>
								</div>
							</div>
						</form>
					</div>
				</div>
			)}
		</div>
	)
}

export default Login;
